type Font = {
  name: string;
  files: { [key: string]: string };
  titleFont?: {
    name: string;
    files: { [key: string]: string };
  };
}

export const fonts: { [key: string]: Font } = {
  collectionparticulière: {
    name: 'Century Modern',
    files: {
      light: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837424/fonts/Century%20Modern/CenturyModern-Light_xni6va.otf',
      light_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837430/fonts/Century%20Modern/CenturyModern-LightItalic_sp11ws.otf',
      regular: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837423/fonts/Century%20Modern/CenturyModern-Book_pkcgnc.otf',
      italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837426/fonts/Century%20Modern/CenturyModern-Italic_bzk4tg.otf',
      bold: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837423/fonts/Century%20Modern/CenturyModern-Bold_h5pjnn.otf',
      bold_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837423/fonts/Century%20Modern/CenturyModern-BoldItalic_veigzr.otf',
    }
  },
  lladró: {
    name: 'Century Modern',
    files: {
      light: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837424/fonts/Century%20Modern/CenturyModern-Light_xni6va.otf',
      light_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837430/fonts/Century%20Modern/CenturyModern-LightItalic_sp11ws.otf',
      regular: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837423/fonts/Century%20Modern/CenturyModern-Book_pkcgnc.otf',
      italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837426/fonts/Century%20Modern/CenturyModern-Italic_bzk4tg.otf',
      bold: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837423/fonts/Century%20Modern/CenturyModern-Bold_h5pjnn.otf',
      bold_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837423/fonts/Century%20Modern/CenturyModern-BoldItalic_veigzr.otf',
    }
  },
  hëlinga: {
    name: 'Lato',
    files: {
      thin: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1781683217/fonts/Lato/Lato-Thin_pxhmbc.ttf',
      thin_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1781683221/fonts/Lato/Lato-ThinItalic_zhjmk7.ttf',
      light: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1781683220/fonts/Lato/Lato-Light_kt8sgi.ttf',
      light_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1781683217/fonts/Lato/Lato-LightItalic_liegve.ttf',
      regular: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1781683220/fonts/Lato/Lato-Regular_wipxaf.ttf',
      italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1781683217/fonts/Lato/Lato-Italic_dnjh0d.ttf',
      bold: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1781683219/fonts/Lato/Lato-Bold_qnpcvv.ttf',
      bold_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1781683220/fonts/Lato/Lato-BoldItalic_qiuwyg.ttf',
      black: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1781683220/fonts/Lato/Lato-Black_yummpr.ttf',
      black_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1781683218/fonts/Lato/Lato-BlackItalic_dragqh.ttf'
    },
    titleFont: {
      name: 'Gilda Display',
      files: {
        regular: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1781683217/fonts/Gilda_Display/GildaDisplay-Regular_od4zzm.ttf',
      }
    }
  },
  liaigre: {
    name: 'Century Modern',
    files: {
      light: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837424/fonts/Century%20Modern/CenturyModern-Light_xni6va.otf',
      light_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837430/fonts/Century%20Modern/CenturyModern-LightItalic_sp11ws.otf',
      regular: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837423/fonts/Century%20Modern/CenturyModern-Book_pkcgnc.otf',
      italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837426/fonts/Century%20Modern/CenturyModern-Italic_bzk4tg.otf',
      bold: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837423/fonts/Century%20Modern/CenturyModern-Bold_h5pjnn.otf',
      bold_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771837423/fonts/Century%20Modern/CenturyModern-BoldItalic_veigzr.otf',
    }
  },
  herculestudio: {
    name: 'Algebra',
    files: {
      bold: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771836492/fonts/Algebra/Algebra-Bold_jiwwex.otf',
      regular: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771836492/fonts/Algebra/Algebra-Regular_qe6zdx.otf',
    }
  },
  delcourtedition: {
    name: 'Algebra',
    files: {
      bold: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771836492/fonts/Algebra/Algebra-Bold_jiwwex.otf',
      regular: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771836492/fonts/Algebra/Algebra-Regular_qe6zdx.otf',
    }
  },
  chanel: {
    name: 'Algebra',
    files: {
      bold: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771836492/fonts/Algebra/Algebra-Bold_jiwwex.otf',
      regular: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771836492/fonts/Algebra/Algebra-Regular_qe6zdx.otf',
    }
  },
  jacquemus: {
    name: 'Algebra',
    files: {
      bold: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771836492/fonts/Algebra/Algebra-Bold_jiwwex.otf',
      regular: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771836492/fonts/Algebra/Algebra-Regular_qe6zdx.otf',
    }
  },
  vasarely: {
    name: 'Algebra',
    files: {
      bold: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771836492/fonts/Algebra/Algebra-Bold_jiwwex.otf',
      regular: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1771836492/fonts/Algebra/Algebra-Regular_qe6zdx.otf',
    }
  },
  'christianlouboutin': {
    name: 'NB Akademie',
    files: {
      regular: 'https://res.cloudinary.com/dnkj85yan/image/upload/v1775118230/D%C3%A9mos/Christian%20Louboutin/Louboutin_3_ensels.jpg',
    },
  },
  andréeputman: {
    name: 'Funkis A.1',
    files: {
      light: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961380/fonts/Funkis%20A.1/FunkisA.1-Light_lbenew.otf',
      light_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961381/fonts/Funkis%20A.1/FunkisA.1-LightItalic_p5zb4i.otf',
      medium: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961381/fonts/Funkis%20A.1/FunkisA.1-Medium_ptj1np.otf',
      medium_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961382/fonts/Funkis%20A.1/FunkisA.1-MediumItalic_jj3a4q.otf',
      regular: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961382/fonts/Funkis%20A.1/FunkisA.1-Regular_npwhpr.otf',
      italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961380/fonts/Funkis%20A.1/FunkisA.1-Italic_kwegkl.otf',
      semibold: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961383/fonts/Funkis%20A.1/FunkisA.1-SemiBold_qyaoed.otf',
      semibold_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961384/fonts/Funkis%20A.1/FunkisA.1-SemiBoldItalic_o4hicg.otf',
      bold: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961380/fonts/Funkis%20A.1/FunkisA.1-Bold_ykyswx.otf',
      bold_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961380/fonts/Funkis%20A.1/FunkisA.1-BoldItalic_cvm6vu.otf',
    }
  },
  adamlippes: {
    name: 'Optima',
    // url: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760515554/fonts/OptimaLTD_hbwomw.ttf',
    files: {
      regular: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961806/fonts/Optima/Optima_LT_Std_Roman_ykeh4u.otf',
      italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961804/fonts/Optima/Optima_LT_Std_Italic_mlokni.otf',
      medium: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961805/fonts/Optima/Optima_LT_Std_Medium_pturne.otf',
      medium_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961804/fonts/Optima/Optima_LT_Std_Medium_Italic_kmhw9g.otf',
      semibold: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961802/fonts/Optima/Optima_LT_Std_Demi_zgjx1a.otf',
      bold: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961800/fonts/Optima/Optima_LT_Std_Bold_bzityg.otf',
      bold_italic: 'https://res.cloudinary.com/dnkj85yan/raw/upload/v1760961801/fonts/Optima/Optima_LT_Std_Bold_Italic_hegrtx.otf',
    }
  }
};

export const weightMap: { [key: string]: number } = {
  thin: 100,
  extralight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
};